import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { COLORS } from '../../styles';
import './TVSlide.scss';

const animations = [
  'rollIn',
  'rubberBand',
  'wobble',
  'jello',
  'bounceIn',
  'fadeInRightBig',
  'fadeInRight',
  'fadeInLeft',
  'flipInX',
  'flipInY',
  'rotateIn',
  'rotateInDownLeft',
  'rollIn',
  'zoomIn',
  'jackInTheBox',
  'slideInLeft',
  'slideInDown'
];

class TVSlide extends PureComponent {
  state = { shouldRender: false, isMouseInside: false, active: false };
  timeout = null;

  UNSAFE_componentWillMount() {
    this.setState({ shouldRender: true, active: true });
  }

  componentWillUnmount() {
    if (this.timeout !== null) {
      clearTimeout(this.timeout);

      this.timeout = null;
    }
  }

  renderRecipients() {
    // Render multiple recipients
    const { recipients } = this.props.shoutout;
    return recipients.map((recipient, i) => (
      <div key={i} className="recipient" style={{ marginRight: 15 }}>
        <img src={recipient.photoURL} alt={recipient.displayName}/>
        <p>{recipient.displayName}</p>
        {recipients.length > 0 && i < (recipients.length - 1) ? ',' : null}
      </div>
    ));
  }

  render() {
    const { active } = this.state;
    const { shoutout, index, light, tags } = this.props;
    if (this.state.shouldRender) {
      const className = `slide ${active ? 'active' : ''}`;
      const animation = active ? `animated ${animations[Math.floor(Math.random() * animations.length)]}` : '';
      const backgroundColor = light ? 'transparent' : COLORS[index % COLORS.length];
      const fontColor = light ? '#4a4a4a' : 'white';
      const messageStyle = shoutout.message.length > 75 && shoutout.imageUrl ? 'left-align message' : 'message';

      return (
        <div className={className} style={{ backgroundColor }}>
          <div className={`animation-wrapper ${animation}`}>

            <div className="sender" style={{ color: fontColor, visibility: (shoutout.winner ? 'hidden' : 'visible') }}>
              <h1 style={{ fontSize: 22, paddingRight: 10, fontWeight: 'bold' }}>To:</h1>
              {this.renderRecipients()}
            </div>
            <div className={messageStyle} style={{ color: fontColor }}>
              { shoutout.imageUrl &&
                <img src={shoutout.imageUrl} className="tv-mode-image" alt=""/>
              }
              <p dangerouslySetInnerHTML={{ __html: shoutout.message }}></p>
            </div>

            <div className="sender" style={{ color: fontColor, visibility: (shoutout.winner ? 'hidden' : 'visible') }}>
              <h1 style={{ fontSize: 22, paddingRight: 10, fontWeight: 'bold' }}>From:</h1>
              <img src={shoutout.sender.photoURL} alt={shoutout.sender.displayName} />
              <p>{shoutout.sender.displayName}</p>
            </div>

            <div className="shoutout-tags-wrapper" style={{ display: shoutout.tags.length ? 'flex' : 'none' }}>
              {shoutout.tags.map(tag =>
                (<div key={tag} className="shoutout-tag" style={{ color: backgroundColor }}>{tags.filter(t => t._id === tag)[0].name}</div>)
              )}
            </div>

          </div>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ tagsStore }) => {
  const { tags } = tagsStore;

  return { tags };
};

export default connect(mapStateToProps)(TVSlide);



// WEBPACK FOOTER //
// ./src/screens/tv/TVSlide.js